import {
  AssetValuation,
  AssetValuationDetails,
} from '@tcs/client-portal-api/types/AssetValuationDetails';
import { useQuery } from '@tcs/common/hooks/useQuery';
interface Props {
  loading: boolean;
  data?: AssetValuationDetails[];
}

interface AssetValuationProps {
  loading: boolean;
  data?: AssetValuation[];
}

export const useValuationDetails = (
  accountNumber?: string,
  options?: { enabled?: boolean },
): Props => {
  const shouldFetch = options?.enabled !== false && accountNumber !== undefined;

  const { data, isLoading: loading } = useQuery<AssetValuationDetails[], Error>(
    `/valuations/accounts/${accountNumber}`,
    {
      refetchOnMount: false,
      enabled: shouldFetch,
    },
  );
  return {
    loading,
    data,
  };
};

export const useValuationDetailsMultiple = (
  accountsNumbers?: string[],
): AssetValuationProps => {
  let queryParams = 'accountsNumbers=[';
  accountsNumbers.forEach((accountNumber, idx) => {
    queryParams += `"${accountNumber}"`;

    if (idx < accountsNumbers.length - 1) {
      queryParams += ',';
    }
  });
  queryParams += ']';

  const { data, isLoading: loading } = useQuery<AssetValuation[], Error>(
    `/valuations/multiple/accounts?${queryParams}`,
    {
      refetchOnMount: false,
      enabled:
        accountsNumbers !== null &&
        accountsNumbers !== undefined &&
        accountsNumbers.length > 0,
    },
  );
  return {
    loading,
    data,
  };
};

export default useValuationDetails;
